/* prettier-ignore-start */
/* tslint:disable */
/* eslint-disable */

/* 该文件工具自动生成，请勿直接修改！！！ */

// @ts-ignore

import request from '@/utils/request/index';
/**
 * 接口 [pv埋点↗](https://yapi.fenxianglife.com/project/379/interface/api/43666) 的 **请求函数**
 *
 * @分类 [数据统计相关↗](https://yapi.fenxianglife.com/project/379/interface/api/cat_10101)
 * @请求头 `POST /data/pv/increment`
 * @更新时间 `2023-09-07 14:56:13`
 */
export const feimaChatDataPvIncrement = <
  OT extends ToolTypes.GetOptionsType<typeof request> = { returnData: true }
>(
  data: ToolTypes.GetRequestType<API.FeimaChatDataPvIncrementRequest>,
  options?: OT
) => {
  // 注释掉，暂时不启用
  // return request<ToolTypes.GetResponseType<API.FeimaChatDataPvIncrementResponse, OT>>(
  //   '/data/pv/increment',
  //   'POST',
  //   data,
  //   options
  // );
}

/* prettier-ignore-end */
